import React from 'react';
import { IGDPRProps } from './IGDPRProps';

const GDPR: React.FC<IGDPRProps> = ({ gdprText, marketingText, requiredText, privacyUrl, gdpr, marketing, updateGdpr, updateMarketing }) => {
   const insertPrivacyLink = (text: string, privacy: URL | null) => {
      let linkText = text.match(/\{(.*)\}/)
      let jsx = []
      if (linkText) {
         let split = text.split(linkText[0])
         if (split[0]) {
            jsx.push(<p className='gdpr-text-part'>{split[0]}</p>)
            if (privacy && privacy.href) {
               jsx.push(<a href={privacy.href} target='_blank' rel='noopener noreferrer'>{linkText[1]}</a>)
            } else {
               jsx.push(<p className='gdpr-text-part'>{linkText[1]}</p>)
            }
         }
         if (split[1]) {
            jsx.push(<p className='gdpr-text-part'>{split[1]}</p>)
         }
         if (!split[0] && !split[1]) {
            if (privacy && privacy.href) {
               jsx.push(<a href={privacy.href} target='_blank' rel='noopener noreferrer'>{linkText[1]}</a>)
            } else {
               jsx.push(<p className='gdpr-text-part'>{linkText[1]}</p>)
            }
         }
      } else {
         jsx.push(<p className='gdpr-text-part'>{text}</p>)
      }
      if (requiredText !== '' && text !== requiredText) {
         jsx.push(<p className='gdpr-text-part'>*</p>)
      }
      return jsx;
   }
   return (
      <div className='gdpr'>
         <div className='data-processing-agreement'>
            <div className='input-wrap'>
               <input type='checkbox' checked={gdpr} name='gdpr' onClick={(e: React.MouseEvent<HTMLElement>) => { updateGdpr() }} />
               <span className='input-checkbox border'></span>
            </div>
            <p className='input-label'>{insertPrivacyLink(gdprText, privacyUrl)}</p>
         </div>
         <div className='marketing-agreement'>
            <div className='input-wrap'>
               <input type='checkbox' checked={marketing} name='marketing' onClick={(e: React.MouseEvent<HTMLElement>) => { updateMarketing() }} />
               <span className='input-checkbox border'></span>
            </div>
            <p className='input-label'>{insertPrivacyLink(marketingText, privacyUrl)}</p>
         </div>
         {requiredText !== '' ?
            <div className='required'>
               <p className='required-text'>* {insertPrivacyLink(requiredText, privacyUrl)}</p>
            </div>
            :
            null
         }
      </div>
   );
};

export default GDPR;
